import styled, { css } from 'styled-components';

const ButtonText = () => css`
    color: ${({ christmasTheme }) => christmasTheme ? 'white;' : '#0A083A;'};
    font-family: SharpSansBold;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    position: relative;
    align-self:center;
    width:100%;
    text-align:center;
    display:flex;
    align-items:center;
    place-content:center;

    @media (max-height: 500px) {
        font-size:11.5px;
    }
`;

export default styled.div([ButtonText]);